export default __webpack_public_path__ + "paddle_sports_hover3256c7.svg";